/**
 * Variant Picker Fix - Ensures proper variant selection and form submission
 * This script addresses conflicts between variant picker and cart functionality
 */

(function() {
  'use strict';
  
  console.log('Variant Picker Fix: Initializing...');
  
  // Wait for DOM to be ready
  function initVariantPickerFix() {
    console.log('Variant Picker Fix: Setting up event listeners...');
    
    // Ensure variant picker events are properly connected
    document.addEventListener('change', function(event) {
      // Check if this is a variant picker change
      if (event.target.closest('variant-picker')) {
        const variantPicker = event.target.closest('variant-picker');
        const productForm = variantPicker.closest('product-form-component');
        
        console.log('Variant picker change detected:', {
          target: event.target,
          variantId: event.target.dataset.variantId,
          productForm: !!productForm
        });
        
        if (productForm) {
          // Ensure the variant ID is immediately updated
          const variantIdInput = productForm.querySelector('input[name="id"]');
          const selectedOption = event.target;
          
          console.log('Variant ID input found:', !!variantIdInput);
          console.log('Selected option variant ID:', selectedOption.dataset.variantId);
          
          if (variantIdInput && selectedOption.dataset.variantId) {
            const oldValue = variantIdInput.value;
            variantIdInput.value = selectedOption.dataset.variantId;
            console.log('Variant Picker Fix: Updated variant ID from', oldValue, 'to', selectedOption.dataset.variantId);
            
            // Trigger change event to notify other listeners
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            
            // Also trigger input event for additional compatibility
            variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            console.warn('Variant Picker Fix: Missing variant ID input or selected option data');
          }
        }
      }
    });
    
    // Override any conflicting app behaviors
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      // Prevent apps from interfering with variant picker events
      if (type === 'change' && this.closest && this.closest('variant-picker')) {
        console.log('Variant Picker Fix: Protecting variant picker change event');
        return originalAddEventListener.call(this, type, function(event) {
          // Ensure our fix runs first
          if (event.target.closest('variant-picker')) {
            const variantPicker = event.target.closest('variant-picker');
            const productForm = variantPicker.closest('product-form-component');
            
            if (productForm) {
              const variantIdInput = productForm.querySelector('input[name="id"]');
              const selectedOption = event.target;
              
              if (variantIdInput && selectedOption.dataset.variantId) {
                variantIdInput.value = selectedOption.dataset.variantId;
                console.log('Variant Picker Fix: Protected update - variant ID:', selectedOption.dataset.variantId);
              }
            }
          }
          
          // Call the original listener
          if (typeof listener === 'function') {
            listener.call(this, event);
          }
        }, options);
      }
      
      return originalAddEventListener.call(this, type, listener, options);
    };
    
    // Monitor form submissions to ensure variant ID is present
    document.addEventListener('submit', function(event) {
      const form = event.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        console.log('Cart form submission detected');
        
        // Mark this as a product form submission
        window.lastCartUpdateSource = 'product-form';
        
        const variantIdInput = form.querySelector('input[name="id"]');
        console.log('Variant ID input value before fix:', variantIdInput?.value);
        
        if (variantIdInput) {
          // Always try to get the current variant ID from the picker
          const variantPicker = form.closest('product-form-component')?.querySelector('variant-picker');
          if (variantPicker) {
            const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
            console.log('Selected option found:', !!selectedOption);
            console.log('Selected option variant ID:', selectedOption?.dataset.variantId);
            
            if (selectedOption?.dataset.variantId) {
              const newVariantId = selectedOption.dataset.variantId;
              if (variantIdInput.value !== newVariantId) {
                console.log('Variant Picker Fix: Updating variant ID from', variantIdInput.value, 'to', newVariantId);
                variantIdInput.value = newVariantId;
                
                // Force events to ensure all listeners are notified
                variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
                variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
              }
            } else {
              console.warn('Variant Picker Fix: No selected option or variant ID found');
            }
          } else {
            console.warn('Variant Picker Fix: No variant picker found in form');
          }
          
          console.log('Final variant ID value:', variantIdInput.value);
        } else {
          console.error('Variant Picker Fix: No variant ID input found in form');
        }
      }
    });
    
    // Add a more direct approach - intercept form submission
    const originalSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function() {
      console.log('Form submit intercepted');
      
      if (this.action && this.action.includes('/cart/add')) {
        const variantIdInput = this.querySelector('input[name="id"]');
        if (variantIdInput) {
          const variantPicker = this.closest('product-form-component')?.querySelector('variant-picker');
          if (variantPicker) {
            const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
            if (selectedOption?.dataset.variantId) {
              console.log('Intercepted submit - updating variant ID to:', selectedOption.dataset.variantId);
              variantIdInput.value = selectedOption.dataset.variantId;
            }
          }
        }
      }
      
      return originalSubmit.call(this);
    };
    
    // CRITICAL: Intercept Recharge cart updates to ensure correct variant
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (url && url.includes('/cart/add')) {
        console.log('Variant Picker Fix: Intercepting cart/add request');
        
        // Get the current form data
        if (options && options.body instanceof FormData) {
          const formData = options.body;
          const variantId = formData.get('id');
          console.log('Intercepted variant ID:', variantId);
          
          // If variant ID is empty or default, try to get it from the picker
          if (!variantId || variantId === '') {
            const activeForm = document.querySelector('form[action*="/cart/add"]');
            if (activeForm) {
              const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
              if (variantPicker) {
                const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
                if (selectedOption?.dataset.variantId) {
                  console.log('Variant Picker Fix: Updating form data with correct variant ID:', selectedOption.dataset.variantId);
                  formData.set('id', selectedOption.dataset.variantId);
                }
              }
            }
          }
        }
      }
      
      return originalFetch.call(this, url, options);
    };
    
    // Also intercept XMLHttpRequest for additional coverage
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._url = url;
      return originalXHROpen.call(this, method, url, ...args);
    };
    
    XMLHttpRequest.prototype.send = function(data) {
      if (this._url && this._url.includes('/cart/add')) {
        console.log('Variant Picker Fix: Intercepting XHR cart/add request');
        
        if (data instanceof FormData) {
          const variantId = data.get('id');
          console.log('XHR Intercepted variant ID:', variantId);
          
          if (!variantId || variantId === '') {
            const activeForm = document.querySelector('form[action*="/cart/add"]');
            if (activeForm) {
              const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
              if (variantPicker) {
                const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
                if (selectedOption?.dataset.variantId) {
                  console.log('Variant Picker Fix: Updating XHR form data with correct variant ID:', selectedOption.dataset.variantId);
                  data.set('id', selectedOption.dataset.variantId);
                }
              }
            }
          }
        }
      }
      
      return originalXHRSend.call(this, data);
    };
    
    console.log('Variant Picker Fix: Initialized successfully');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPickerFix);
  } else {
    initVariantPickerFix();
  }
  
  // Re-initialize after dynamic content changes (for apps like Recharge)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches && node.matches('variant-picker, product-form-component'))) {
            console.log('Variant Picker Fix: New variant picker/form detected, re-initializing...');
            setTimeout(initVariantPickerFix, 100);
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
